import React from "react";
import PropTypes from "prop-types";
import getStoriesByCollection from "../../../utils";
import { TwoColStoryCard } from "../../molecules/two-col-story-card";
import HorizontalStoryCard from "../../molecules/horizontal-story-card";
import "./two-rows-three-stories.m.css";

export const TwoRowsFourStories = ({ collection }) => {
  const stories = getStoriesByCollection(collection);
  if (stories.length < 1) {
    return null;
  }

  return (
    <div styleName="wrapper">
      {stories.slice(0, 1).map((story, index) => (
        <TwoColStoryCard story={story} key={index} />
      ))}
      {stories.length > 1 && (
        <div styleName="second-card">
          {stories.slice(1, 4).map(story => (
            <HorizontalStoryCard
              story={story}
              descriptionTopMargin={true}
              key={story.id}
              boxPadding={false}
              descriptionPadding={false}
              showTime={false}
              hideAuthorWithTime
            />
          ))}
        </div>
      )}
    </div>
  );
};

TwoRowsFourStories.storyLimit = 8;

TwoRowsFourStories.propTypes = {
  collection: PropTypes.object
};
